
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DARTISC",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DARTISC.vue